import { Enum } from './enum.class.js';
import EnumItem from './enumItem.class.js';

/**
 * Enum para origem da tarefa
 * Equivalente ao enum Java OrigemTarefa
 */
class OrigemTarefaEnum extends Enum {
    constructor() {
        super();
        this.NENHUMA = new EnumItem(0, 'NENHUMA');
        this.ATENDIMENTO = new EnumItem(1, 'ATENDIMENTO');
        this.DEPARTAMENTO_PESSOAL = new EnumItem(2, 'DEPARTAMENTO_PESSOAL');
        this.ELEGALIZE = new EnumItem(3, 'ELEGALIZE');
        this.EEXTRATOS = new EnumItem(4, 'EEXTRATOS');
        this.CERTIFICADOS_DIGITAIS = new EnumItem(5, 'CERTIFICADOS_DIGITAIS');
    }
}

export const origemTarefaEnum = new OrigemTarefaEnum();
